module.exports = __webpack_public_path__ + "static/media/monitor-heart-rate.09a9a883.svg";